module.exports = __webpack_public_path__ + "static/media/ICBT 31T Driven.5bbbc822.jpg";